export const washMinutes: number = 7;
export const washMicroSeconds: number = 420000;
